import React, { useContext } from 'react';
import { ApolloProvider } from '@apollo/client';

import '../styles/app.scss';
import AppContext, { AppContextType } from '../context';
import Layout from './Layout';
import RouteBundler from './RouteBundler';
import routes from '../routes';

export function App() {
  const { client } = useContext(AppContext) as AppContextType;

  return (
    <ApolloProvider client={client}>
      <Layout>
        <RouteBundler routes={routes} />
      </Layout>
    </ApolloProvider>
  );
}

export default App;
